import React = require("react");
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import "./PredictiveMaintenanceQuestionaire.scss";
import {TerminalAddAlarmNotePanel} from "./PredictiveMaintenanceTerminalDummyWorkOrderNode";

declare var AppTranslations: AppTranslations;

interface PredictiveMaintenanceTerminalDummyNodeProps {
    fault: string;
    openWorkOrder: () => void;
    resetAllAnswers: () => void;
    alarmData: any;
    alarmPanel: any;
}

// tslint:disable-next-line:max-line-length
export class PredictiveMaintenanceTerminalDummyNode extends React.Component<PredictiveMaintenanceTerminalDummyNodeProps, any> {
    constructor(props: PredictiveMaintenanceTerminalDummyNodeProps) {
        super(props);
    }

    public clickReset = () => {
        this.props.resetAllAnswers();
    }

    public clickOpenWorkOrder = () => {
        this.props.openWorkOrder();
    }

    public render() {
        return (
            <div className="alarmPanelQuestion">
                {!this.props.alarmData.useDummyWorkOrder ? <div id="alarmPanelTerminalQuestionOpenWorkOrderTemplate">
                    <div className="alarmPanelQuestionMarginContent">
                        <div className="alarm-panel-question-terminal-node"/>
                    </div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className="alarmPanelQuestionMarginContent alarmPanelQuestionRightMarginContent alarmPanelTerminalQuestionWork">
                        <div className="verticalAlign"/>
                        <div
                            id="openWorkAlarmPredictive"
                            className="alarm-panel-terminal-question-right-button-content"
                        >
                            <p style={{marginBottom: "5px"}}>
                                {AppTranslations.predictiveTranslation.dummyTerminalNodeTitle}
                            </p>
                            <div style={{display: "display: inline-block;"}}>
                                <div
                                    id="alarmDetailButtonfilteredDiagnosis"
                                    className="alarmDetailButtonWrapper"
                                    onClick={this.clickReset}
                                    style={{verticalAlign: "top"}}
                                >
                                    <div className="alarmDetailButton">
                                        <div className="onButton">
                                            <div
                                                className="icon resetIcon"
                                            />
                                        </div>
                                        <div
                                            className="icon resetIcon"
                                        />
                                    </div>
                                    <p className="alarmDetailButtonDescription">
                                        {AppTranslations.predictiveTranslation.backToBeginning}
                                    </p>
                                </div>
                                <div
                                    id="alarmDetailButtonfilteredDiagnosis"
                                    className="alarmDetailButtonWrapper"
                                    onClick={this.clickOpenWorkOrder}
                                    style={{verticalAlign: "top"}}
                                >
                                    <div className="alarmDetailButton">
                                        <div className="onButton">
                                            <div className="icon alarmOpenWorkOrderIcon"/>
                                        </div>
                                        <div className="icon alarmOpenWorkOrderIcon"/>
                                    </div>
                                    <p className="alarmDetailButtonDescription">
                                        {AppTranslations.predictiveTranslation.openWorkOrderTitle}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <TerminalAddAlarmNotePanel
                    alarmGuid={this.props.alarmData.alarmGuid}
                    alarmPanel={this.props.alarmPanel}
                />}
            </div>
        );
    }
}
